module.exports = __webpack_public_path__ + "img/pintel.76534abc.jpeg";